define(["require", "exports", "./utils/Environment"], function (require, exports, Environment_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ROUTE_LOGIN = exports.USER_TOKEN = void 0;
    function makeConstant(k) {
        return `srms_${(0, Environment_1.getEnvironment)()}_${k}`.toLowerCase();
    }
    exports.USER_TOKEN = makeConstant("user_token");
    exports.ROUTE_LOGIN = "/login";
});
